import React from 'react';

export const renderEventContent = (eventInfo, rsvpStatusMap) => {
  const style = {};
  const hostedBy = eventInfo.event.extendedProps.hostedBy;
  if(eventInfo.event.borderColor)
    style.border = `1px solid ${ eventInfo.event.borderColor }`;

  const rsvpStatus = eventInfo.event.extendedProps.rsvpStatus;
  const className = `cui-full-calendar-event p-2 font-12 ${ rsvpStatus == rsvpStatusMap.no ? "todo-completed" : "" } ${ eventInfo.event.extendedProps.isUpcomingEvent ? "" : "cui-past-event"}`;

  return (
    <div className={ className } style={ style }>
      <div className="text-truncate pt-1">
        { getIconIfApplicable(rsvpStatus, rsvpStatusMap) }
        { eventInfo.event.extendedProps.displayStartTime }
      </div>
      <div className="text-truncate font-600"> { eventInfo.event.title } </div>
      { hostedBy && <div className="text-truncate">{ hostedBy }</div> }
    </div>
  );
};

const getIconIfApplicable = (rsvpStatus, rsvpStatusMap) => {
  const rsvpStatusFaIconMap = {
    [rsvpStatusMap.yes]: "fa-circle-check",
    [rsvpStatusMap.maybe]: "fa-circle-question"
  };

  if(rsvpStatus in rsvpStatusFaIconMap)
    return <i className={ `fa-light ${rsvpStatusFaIconMap[rsvpStatus]} font-14 float-right` } />
}
